import React, { useState } from 'react';
import { useGetBatchQuery } from '../../../store/batchApi';
import { useSaveNotificationMutation } from '../../../store/notificationApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import { toast } from 'sonner';

type NotificationModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const NotificationModal: React.FC<NotificationModalProps> = ({
  open,
  setOpen,
}) => {
  const { data: allBatch } = useGetBatchQuery();
  const [saveNotification, { isLoading }] = useSaveNotificationMutation();
  const { user } = useSelector((state: RootState) => state.user);

  const [notification, setNotification] = useState({ batch: '', message: '' });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setNotification((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!notification.batch || !notification.message) {
      toast.error('Please fill in all fields');
      return;
    }

    try {
      await saveNotification({
        data: notification,
        token: user?.token,
      }).unwrap();
      toast.success('Notification sent successfully!');
      setNotification({ batch: '', message: '' });
      setOpen(false);
    } catch {
      toast.error('Failed to send notification');
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 md:mt-0 mt-10">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-lg w-96 dark:text-white">
        <h2 className="text-lg font-semibold mb-4">Add Notification</h2>

        <label className="block text-sm font-medium mb-2">Select Batch</label>
        <select
          name="batch"
          className="w-full p-2 border rounded mb-4 dark:bg-gray-700 dark:text-white"
          value={notification.batch}
          onChange={handleChange}
        >
          <option value="">Select Batch</option>
          {allBatch?.map((batch: Batch) => (
            <option key={batch._id} value={batch?.bCode}>
              {batch.bCode} ({(batch.startTime, batch.endTime)})
            </option>
          ))}
        </select>

        <label className="block text-sm font-medium mb-2">
          Notification Message
        </label>
        <textarea
          name="message"
          className="w-full p-2 border rounded mb-4 dark:bg-gray-700 dark:text-white"
          rows={3}
          value={notification.message}
          onChange={handleChange}
          placeholder="Enter notification message..."
        ></textarea>

        <div className="flex justify-end gap-2">
          <button
            className="border px-4 py-2 rounded-lg"
            onClick={() => setOpen(false)}
          >
            Cancel
          </button>
          <button
            className="bg-black text-white px-4 py-2 rounded-lg"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
